import React from "react";
import { LOGO_URL } from "@/lib/config";

export default function AdminLogin() {
  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };
  return (
    <div data-testid="admin-login-page" className="min-h-[70vh] flex items-center justify-center px-6 py-16">
      <div className="w-full max-w-md rounded-3xl border border-black/10 bg-white p-10 text-center">
        <img src={LOGO_URL} alt="Jfeva" className="h-14 w-14 mx-auto rounded-md object-contain"/>
        <div className="mt-4 eyebrow text-[color:var(--brand-wood)]">Admin</div>
        <h1 className="mt-2 font-display text-3xl">Sign in to manage Jfeva</h1>
        <p className="mt-3 text-sm text-[color:var(--brand-woodDark)]">
          Access quote requests, bookings, gallery, and estimates.
        </p>
        <button data-testid="admin-google-login" onClick={login}
          className="mt-8 inline-flex items-center gap-3 w-full justify-center rounded-full bg-[color:var(--brand-ink)] text-[color:var(--brand-cream)] px-6 py-3 text-sm font-medium hover:-translate-y-0.5 transition-transform">
          <svg className="h-4 w-4" viewBox="0 0 48 48"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32 29.4 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.9 6.9 29.2 5 24 5 13.5 5 5 13.5 5 24s8.5 19 19 19 19-8.5 19-19c0-1.2-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.6 15.7 18.9 13 24 13c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.9 6.9 29.2 5 24 5 16.3 5 9.7 9.4 6.3 14.7z"/><path fill="#4CAF50" d="M24 43c5.2 0 9.9-1.8 13.5-4.9l-6.2-5.2c-2 1.4-4.6 2.1-7.3 2.1-5.4 0-9.9-3-11.4-7.2l-6.6 5.1C9.6 38.4 16.2 43 24 43z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.3-2.3 4.3-4.2 5.9l6.2 5.2c-.4.4 6.7-4.9 6.7-15.1 0-1.2-.1-2.4-.4-3.5z"/></svg>
          Continue with Google
        </button>
        <p className="mt-6 text-xs text-[color:var(--brand-woodDark)]">Powered by Emergent Auth</p>
      </div>
    </div>
  );
}
